<template>
  <div class="page-r">

    <div class="page-r-con">
      <div class="title">Categories</div>
      <div class="tags">
        <div class="tag" @click="goToCategory('news')">News & Events</div>
        <div class="tag" @click="goToCategory('media')">Media Coverage</div>
      </div>
      <div class="title">Recent Posts</div>
      <div class="recent-list" v-if="rightList &&rightList.length>0">
        <div class="recent-item" v-for="(item, index) in rightList" :key="index"  @click="api.goToDetail(item)">
          <div class="text">{{item.title}}</div>
          <div class="news-date">{{item.publishTime | format}}</div>
        </div>
      </div>
      <!-- <div class="title">Tags</div>
      <div class="tags" v-if="tagList">
        <div class="tag" v-for="(item, index) in tagList" :key="index" @click="goToTag(item.tagInUrl)">
          {{item.tagName}}
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import moment from 'moment'

  export default {
    data() {
      return {
        rightList: [],
        tagList: [],
        api: api,
      }
    },
    created() {
      this.getRightList()
      this.getTagsList()
    },
    mounted() {

    },
    filters: {
      format(val) {
        return moment(val).format('MMMM DD, YYYY') // 默认为英文、引入后设置格式
      }
    },
    methods: {
      goToCategory(categoryInUrl) {
        window.open(`/news/category/${categoryInUrl}`, '_self')
      },
      goToTag(tagInUrl) {
        window.open(`/news/tag/${tagInUrl}`, '_self')
      },
      getRightList() {
        api.getNewsFive().then(res => {
          if (res.status === 200) {
            this.rightList = res.data
          } else {
            this.$message({
              message: res.message,
              type: 'warning'
            })
          }
        }).catch(err => {
          console.log(err)
        })
      },
      getTagsList() {
        api.getTags().then(res => {
          if (res.status === 200) {
            this.tagList = res.data
          } else {
            this.$message({
              message: res.message,
              type: 'warning'
            })
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    computed: {}
  }
</script>

<style lang="scss" scoped>
  .page-r {
    /* Background */

    background: #F6F8FA;
    box-shadow: inset 0px 1px 0px #D7D9DD;
    padding:40px 16px 120px 16px;

    .page-r-con {
      padding-bottom: 40px;

      .title {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 32px;
        margin-bottom: 20px;
        clear: left;
      }

      .recent-list {
        // padding-bottom: 20px;
        // border-bottom: 1px solid #D7D9DD;
        // margin-bottom: 40px;

        .recent-item {
          padding: 20px;
          margin-bottom: 20px;
          /* white */

          background: #FFFFFF;
          /* Line */

          border: 1px solid #D7D9DD;
          box-sizing: border-box;
          border-radius: 8px;

          .text {
            font-family: Montserrat;
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            line-height: 24px;
            /* or 150% */

            /* Black */

            color: #000000;
            margin-bottom: 10px;
          }

          .news-date {
            font-family: Montserrat;
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            line-height: 24px;
            /* identical to box height, or 150% */

            /* Gray Blue */

            color: #2788F0;

          }
        }

      }

      .tags {
        .tag {
          width: auto;
          height: 35px;
          /* white */
          background: #FFFFFF;
          /* Line */

          border: 1px solid #D7D9DD;
          box-sizing: border-box;
          border-radius: 8px;
          margin-right: 15px;
          margin-bottom: 15px;
          float: left;
          font-family: Montserrat;
          font-style: normal;
          font-weight: 500;
          font-size: 13px;
          line-height: 35px;
          /* identical to box height, or 150% */

          /* Gray Blue */

          color: #2788F0;
          padding: 0 20px;

        }
      }
    }
  }
</style>
